export default {"src":"/_next/static/image/src/images/Homepage/box-puptainer.08e83849b1a42500f7e75f2075e011ea.svg","height":66,"width":106};